import React from 'react';
import { DataGrid } from '../common/datagrid/ResponsiveDataGrid';
import CustomToolbar from '../common/datagrid/CustomToolbar';
import CustomLoadingOverlay from '../common/datagrid/CustomLoadingOverlay';

// billflow 전용 목록 그리드 (읽기전용 + 상태/액션 컬럼)
const BillFlowList = ({ columns, rows, loading }) => {
  const [pageSize, setPageSize] = React.useState(20);

  return (
    <div style={{ display: 'flex', height: 'calc(100vh - 280px)' }}>
      <div style={{ flexGrow: 1 }}>
        <DataGrid
          rows={rows || []}
          columns={columns}
          getRowId={(row) => row.invUuid}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: CustomLoadingOverlay,
          }}
          componentsProps={{ toolbar: { fileName: '세금계산서_흐름' } }}
          loading={loading}
          initialState={{
            pinnedColumns: {
              left: ['status', 'invNo'],
              right: ['actions'],
            },
          }}
          pageSize={pageSize}
          onPageSizeChange={(v) => setPageSize(v)}
          rowsPerPageOptions={[5, 10, 20, 50, 100]}
          pagination
          disableSelectionOnClick
        />
      </div>
    </div>
  );
};

export default BillFlowList;
